<script lang="ts">
	import GenderIcon from './GenderIcon.svelte';

	const FEMALE = 'female';
	const MALE = 'male';

	export let gender = null;
	export let clickable = true;
	export let small: boolean;

	const oposite = (gndr: string) => (gndr && gndr === MALE ? FEMALE : MALE);

	const toggleGender = (event: Event, newGender: string) => {
		event.preventDefault();
		if (!gender) {
			gender = oposite(newGender);
		} else {
			// if (gender !== newGender) gender = null;
			gender = gender !== newGender ? null : oposite(newGender);
		}
	};
</script>

<GenderIcon
	{small}
	{clickable}
	active={!gender || gender === FEMALE}
	on:click={(e) => toggleGender(e, FEMALE)}
	female
/>
<GenderIcon
	{small}
	{clickable}
	active={!gender || gender === MALE}
	on:click={(e) => toggleGender(e, MALE)}
/>
